import styled, { css } from 'styled-components'
import { themeMedia, themeStyles } from '../../../styles/theme'

const tagSize = '14px'
const tagSizeDesktop = '20px'

export const StyledTagsWrapper = styled.div`
  position: absolute;
  top: 5px;
  right: 5px;
  width: calc(100% - 10px);

  display: flex;
  flex-direction: row-reverse;
  justify-content: end;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.12em;
  ${themeMedia.tablet`
    gap: 0.28em;
  `}

  > div {
    height: ${tagSize};
    ${themeMedia.tablet`
      height: ${tagSizeDesktop};
    `}
    border-radius: 2px;
  }
`

const TextTagBase = css`
  display: flex;
  align-items: center;
  padding: 0 0.4em;
  font-size: 0.5rem;
  ${themeMedia.tablet`
    font-size: 0.67rem;
  `}
  font-weight: 400;
  text-transform: uppercase;
`

export const StyledDropsWinsTag = styled.div`
  ${TextTagBase}
  background-color: ${themeStyles.colors.gametags.dropsWins.main};
  color: ${themeStyles.colors.gametags.dropsWins.contrast};
  order: 0;
`
export const StyledVaultTag = styled.div`
  ${TextTagBase}
  background-color: ${themeStyles.colors.gametags.vaultBoost.main};
  color: ${themeStyles.colors.gametags.vaultBoost.contrast};
  order: 1;
`
export const StyledExclusiveTag = styled.div`
  ${TextTagBase}
  background-color: ${themeStyles.colors.gametags.exclusive.main};
  color: ${themeStyles.colors.gametags.exclusive.contrast};
  order: 2;
`
export const StyledNewTag = styled.div`
  ${TextTagBase}
  background-color: ${themeStyles.colors.primary.main};
  color: ${themeStyles.colors.primary.contrast};
  order: 3;
`
export const StyledTopTag = styled.div`
  ${TextTagBase}
  background-color: ${themeStyles.colors.accentColors.secondary.main};
  color: ${themeStyles.colors.black.main};
  order: 4;
`

export const StyledVoiceOverTag = styled.div`
  ${TextTagBase}
  background-color: ${themeStyles.colors.gametags.voiceOver?.main};
  color: ${themeStyles.colors.gametags.voiceOver?.contrast};
  order: 5;
`

export const StyledComingSoonTag = styled.div`
  ${TextTagBase}
  background-color:${themeStyles.colors.gametags.comingSoon?.main};
  color: ${themeStyles.colors.gametags.comingSoon?.contrast};
`

export const StyledTag = styled.div`
  height: ${tagSize};
  width: ${tagSize};
  ${themeMedia.tablet`
    height: ${tagSizeDesktop};
    width: ${tagSizeDesktop};
  `}
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-image: url('${(props) => props.tag}');
`
